export default function PrintIcon(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5 7.5V3.5H14.5V7.5M5.5 14H4.5C3.67 14 3 13.33 3 12.5V9C3 8.17 3.67 7.5 4.5 7.5H15.5C16.33 7.5 17 8.17 17 9V12.5C17 13.33 16.33 14 15.5 14H14.5M5.5 11.5H14.5V17H5.5V11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
